// 공개 링크 규칙 — 인메모리·Supabase·액션이 한 벌을 쓴다.

import {
  MAX_ACTIVE_PUBLIC_PAGES,
  MAX_FEATURED_PORTFOLIOS,
  type PublicPage,
  type PublicPageInput,
} from "./types";

export const PUBLIC_PAGE_CODE_LENGTH = 12;
export const PUBLIC_PAGE_CODE_ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";

export const PUBLIC_PAGE_NOT_FOUND_MESSAGE = "공개 링크를 찾을 수 없습니다";
// `0049` public_page_portfolio_guard 가 올리는 문구와 같다.
export const PUBLIC_PAGE_PORTFOLIO_MISSING_MESSAGE = "대표 사례를 찾을 수 없습니다";
export const PUBLIC_PAGE_LIMIT_MESSAGE = `켜 둔 공개 링크는 ${MAX_ACTIVE_PUBLIC_PAGES}개까지입니다. 쓰지 않는 링크를 끄고 다시 해 주세요`;
export const PUBLIC_PAGE_PORTFOLIO_GONE_MESSAGE = "고르신 사례가 방금 지워졌습니다. 시트를 다시 열어 주세요";
export const PUBLIC_PAGE_NAME_MESSAGE = "이름은 1~40자로 적어 주세요";
export const PUBLIC_PAGE_FEATURED_MESSAGE = `대표 사례는 ${MAX_FEATURED_PORTFOLIOS}개까지 고를 수 있습니다`;

const CODE_PATTERN = new RegExp(`^[a-z0-9]{${PUBLIC_PAGE_CODE_LENGTH}}$`);

export const isPublicPageCode = (code: string): boolean => CODE_PATTERN.test(code);

export const publicPagePath = (code: string): string => `/s/p/${encodeURIComponent(code)}`;

// 이름은 앞뒤 공백을 털고 · A 는 대표 사례 목록을 쓰지 않아 비우고 · B 는 중복을 빼고 앞에서 6개.
export const normalizePublicPageInput = (input: PublicPageInput): PublicPageInput => ({
  name: input.name.trim(),
  layout: input.layout,
  hero_portfolio_id: input.hero_portfolio_id || null,
  featured_ids: input.layout === "STORY" ? [...new Set(input.featured_ids.filter(Boolean))].slice(0, MAX_FEATURED_PORTFOLIOS) : [],
});

export const portfolioIdsOf = (input: Pick<PublicPageInput, "hero_portfolio_id" | "featured_ids">): string[] => [
  ...(input.hero_portfolio_id ? [input.hero_portfolio_id] : []),
  ...input.featured_ids,
];

// 켜 둔 링크가 상한 아래인가 — 꺼 둔 링크는 세지 않는다(지울 수 없으므로).
export const canActivateMore = (pages: readonly Pick<PublicPage, "active">[]): boolean =>
  pages.filter((p) => p.active).length < MAX_ACTIVE_PUBLIC_PAGES;

// QR 내려받기 파일명.
export const publicPageQrFileName = (code: string): string => `buildpy-portfolio-${code}.svg`;
